import { render, staticRenderFns } from "./InventaireStock.vue?vue&type=template&id=06096b7d&"
import script from "./InventaireStock.vue?vue&type=script&lang=js&"
export * from "./InventaireStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports